export default __webpack_public_path__ + "static/media/keys.feadc017.png";